import React from 'react';
import { AmityCommentTrayComponent } from '@frn/amityco-ui-kit-open-source';

const SocialPlusContentCommentTray = ({ productSlug, contentSlug }) => {
  return (
    <>
      <h4>Leave a comment...</h4>
      <AmityCommentTrayComponent referenceId={`${productSlug}-${contentSlug}`} referenceType="content" />
    </>
  );
};

export default SocialPlusContentCommentTray;
